import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { ParticipantInformationInterface } from '../../reducers/docs/syncUi/types'

/**
 * Returns the local participant's information from room.participantInformation
 * @param state The Redux state
 */

const getParticipantInformation = (state: State): ParticipantInformationInterface[] => state.room.participantInformation
const getLocalBTID = (state: State): string | null => state.user.BTID

export default createSelector(
  [getParticipantInformation, getLocalBTID],
  (participants, localBTID): ParticipantInformationInterface | undefined =>
    participants.find(({ id }) => id === localBTID)
)


